/**
 * サービスセクション 無限テキストスクロール
 *
 * ベース速度で常に左へ流れ、スクロール下でやや加速、
 * スクロール上で減速・逆流する。
 */
document.addEventListener("DOMContentLoaded", function () {
  var el = document.querySelector(".scroll_area .infinity_image._bg1");
  if (!el || typeof window.gsap === "undefined") return;

  var xPos = 0;
  var scrollInfluence = 0;
  var baseSpeed = 0.55;   // px/frame の基本速度（CSS 版の約 0.83px/frame よりやや遅め）
  var scrollFactor = 0.02; // 変更: 0.14 → 0.02（スクロール時の加速を大幅に抑え、ほぼ等速に）
  var damping = 0.91;      // 慣性の減衰率（1 に近いほどゆっくり収束）
  var lastScrollY = window.scrollY;

  window.gsap.ticker.add(function () {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;

    // スクロール量を速度へ変換し、減衰させる
    scrollInfluence = scrollInfluence * damping + delta * scrollFactor;

    xPos -= baseSpeed + scrollInfluence;

    el.style.backgroundPositionX = xPos + "px";
  });
});
